<template>
  <div class="sidebar">
    <h3 class="sidebar-title">数据目录</h3>
    <ul class="sub-menu">
      <li><router-link to="/graduates" class="router-link" :class="{active: $route.path === '/graduates'}">东亚同文书院学生名录</router-link></li>
      <li><router-link to="/faculty" class="router-link" :class="{active: $route.path === '/faculty'}">东亚同文书院教职工名录</router-link></li>
      <li><router-link to="/travel-routes" class="router-link" :class="{active: $route.path === '/travel-routes'}">“大旅行”调查路线与人员</router-link></li>
      <li><router-link to="/travel-topics" class="router-link" :class="{active: $route.path === '/travel-topics'}">大旅行调查题目</router-link></li>
      <li><router-link to="/personnel" class="router-link" :class="{active: $route.path === '/personnel'}">东亚同文会本部人员名录</router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Sidebar'
}
</script>

<style scoped>
.sidebar {
  background-color: var(--white);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  padding: clamp(15px, 2vw, 20px);
  height: fit-content;
  position: sticky;
  top: 80px;
  align-self: start;
}

.sidebar-title {
  font-size: clamp(1rem, 2vw, 1.1rem);
  color: var(--primary-color);
  margin-bottom: clamp(15px, 2vw, 20px);
  padding-bottom: 8px;
  border-bottom: 2px solid var(--medium-gray);
}

.sub-menu {
  list-style: none;
}

.sub-menu li {
  margin-bottom: 8px;
}

.router-link {
  display: block;
  padding: clamp(10px, 1.5vw, 12px) clamp(12px, 1.5vw, 15px);
  background-color: var(--light-gray);
  color: var(--dark-gray);
  text-decoration: none;
  border-radius: var(--border-radius);
  transition: var(--transition);
  font-weight: 500;
  font-size: clamp(0.9rem, 1.8vw, 1rem);
}

.router-link:hover,
.router-link.active {
  background-color: var(--primary-dark);
  color: var(--white);
}

@media (max-width: 768px) {
  .sidebar {
    position: static;
    order: 2;
  }
}
</style>